<script>
    export default {
        name: "login-form",
        props: {
            url: String
        }
    }
</script>

<template>
    <div class="login-form px-4 mb-4">
        <form role="form" method="POST" :action="url">
            <slot/>
        </form>
    </div>
</template>

<style scoped>
    .login-form {
        width: 100%;

        input {
            margin-top: 8px;
            margin-bottom: 8px;
        }
    }
</style>
